import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Csv: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[34px] h-[40px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="40"
    viewBox="0 0 34 40"
    fill="none"
  >
    <path
      d="M0 3C0 2.20435 0.31607 1.44129 0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0H23.333L33.333 10V37C33.333 37.7956 33.0169 38.5587 32.4543 39.1213C31.8917 39.6839 31.1286 40 30.333 40H3C2.20435 40 1.44129 39.6839 0.87868 39.1213C0.31607 38.5587 0 37.7956 0 37V3Z"
      fill="#F5F5F5"
    />
    <path
      d="M0 28H33.333V37C33.333 37.7956 33.0169 38.5587 32.4543 39.1213C31.8917 39.6839 31.1286 40 30.333 40H3C2.20435 40 1.44129 39.6839 0.87868 39.1213C0.31607 38.5587 0 37.7956 0 37V28Z"
      fill="#348560"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0202 33.6972C14.9362 32.7382 14.1312 32.2622 13.2282 32.2622C12.0592 32.2622 11.3242 33.0882 11.3242 34.2432C11.3242 35.3562 12.1362 36.1052 13.2282 36.1052C14.1942 36.1052 14.9502 35.5452 15.0552 34.5722H13.9002C13.8442 34.9572 13.6342 35.1952 13.2212 35.1952C12.7172 35.1952 12.5142 34.7122 12.5142 34.2432C12.5142 33.7392 12.6192 33.1722 13.2842 33.1722C13.5852 33.1722 13.8582 33.3892 13.8652 33.6972H15.0202ZM15.4386 34.8032C15.4736 35.8182 16.3556 36.1052 17.2166 36.1052C18.0356 36.1052 18.9596 35.7832 18.9596 34.8102C18.9596 34.5092 18.7706 33.9772 18.0356 33.8302C17.9301 33.8072 17.8152 33.7863 17.6984 33.7651C17.211 33.6764 16.6916 33.5819 16.6916 33.3052C16.6916 33.0532 17.0066 33.0322 17.2026 33.0322C17.3496 33.0322 17.4826 33.0602 17.5806 33.1232C17.6786 33.1862 17.7346 33.2842 17.7346 33.4382H18.8336C18.7916 32.4932 17.9586 32.2622 17.1606 32.2622C16.4466 32.2622 15.5016 32.5002 15.5016 33.3752C15.5016 34.2059 16.1756 34.3476 16.8372 34.4866C16.9561 34.5115 17.0745 34.5364 17.1886 34.5652C17.1993 34.5677 17.2104 34.5702 17.2218 34.5728C17.2296 34.5745 17.2376 34.5763 17.2458 34.5781C17.4594 34.6254 17.7696 34.6942 17.7696 34.9502C17.7696 35.2372 17.4406 35.3352 17.2096 35.3352C17.0416 35.3352 16.8806 35.2932 16.7686 35.2092C16.6496 35.1182 16.5726 34.9852 16.5726 34.8032H15.4386ZM21.7083 32.3672H22.9193L21.7013 36.0002H20.3293L19.1183 32.3672H20.3573L21.0223 34.7682H21.0363L21.7083 32.3672Z"
      fill="white"
    />
    <path
      d="M25.8648 9.9901C25.207 9.9901 24.5762 9.72882 24.1111 9.26373C23.646 8.79864 23.3848 8.16784 23.3848 7.5101V0.0581055L33.3308 9.9901H25.8648Z"
      fill="#DBDBDB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14.48H12.96V12H8V14.48ZM12.96 18.613H8V16.133H12.96V18.613ZM12.96 22.747H8V20.267H12.96V22.747ZM24.533 18.613H14.613V16.133H24.533V18.613ZM14.613 22.747H24.533V20.267H14.613V22.747ZM14.613 14.48V12H24.533V14.48H14.613Z"
      fill="#CFCFCF"
    />
  </svg>
);

export default Csv;
